import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _26843172 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _622077f1 = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _376c5b10 = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _3d626e09 = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _aa2b8706 = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _f75d623e = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _2db47e33 = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _859a3740 = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _49d37cf4 = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _7fafa662 = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _8113d81e = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _582253fc = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _0f24df92 = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _deba8170 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _3bf6c136 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _37b8f972 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _47f2f33d = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _e30f750a = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _45853e0b = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _5ddbc908 = () => interopDefault(import('../src/pages/companies/_company_id/projects.vue' /* webpackChunkName: "pages/companies/_company_id/projects" */))
const _65c12cea = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _34ad3815 = () => interopDefault(import('../src/pages/companies/_company_id/projects/calendar.vue' /* webpackChunkName: "pages/companies/_company_id/projects/calendar" */))
const _5fc4d79e = () => interopDefault(import('../src/pages/companies/_company_id/projects/gantt-chart.vue' /* webpackChunkName: "pages/companies/_company_id/projects/gantt-chart" */))
const _15d43ba2 = () => interopDefault(import('../src/pages/companies/_company_id/projects/member-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/member-allocation/index" */))
const _a093b0ce = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _c7ff5a9a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _6bc2c6f6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _1f9746b8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _108be261 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _56fc211f = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _b62db146 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _da8565b4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _2bb5aea6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/index" */))
const _255321e6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _3ea7600c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _8fa64574 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _089ee66c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _46e93ace = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _7975e446 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _2076ddef = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _771fa1e5 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _b0967e54 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/select-daily-reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/select-daily-reports" */))
const _43b626d7 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _8206fa48 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _7a0e5804 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _25a12584 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _704fb5f9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _1692a5f6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _b44af334 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _dbad7cb2 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _4973b9a6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _af378fb4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _3b3cc75c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _3bb4dd20 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/form.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/form" */))
const _04c1e7c8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/preview" */))
const _b3e61638 = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _33a51732 = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _4cc6f288 = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _cec2ccfc = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _0dcb44b5 = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _093baf07 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _9c4e0462 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _984a1136 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _4af64bbd = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _20f736ae = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/ai_pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/ai_pdf" */))
const _5e74af9d = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _ea8fe9a2 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _1a219ef3 = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _370647bb = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _26843172,
      name: "companies"
    }, {
      path: "/logout",
      component: _622077f1,
      name: "logout"
    }, {
      path: "/sign_in",
      component: _376c5b10,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _3d626e09,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _aa2b8706,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _f75d623e,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/user-profile",
      component: _2db47e33,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/callback",
      component: _859a3740,
      name: "sessions-callback"
    }, {
      path: "/sessions/invitation",
      component: _49d37cf4,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _7fafa662,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _8113d81e,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _582253fc,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _0f24df92,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _deba8170,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _3bf6c136,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _37b8f972,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _47f2f33d,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _e30f750a,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _45853e0b,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _5ddbc908,
      children: [{
        path: "",
        component: _65c12cea,
        name: "companies-company_id-projects"
      }, {
        path: "calendar",
        component: _34ad3815,
        name: "companies-company_id-projects-calendar"
      }, {
        path: "gantt-chart",
        component: _5fc4d79e,
        name: "companies-company_id-projects-gantt-chart"
      }, {
        path: "member-allocation",
        component: _15d43ba2,
        name: "companies-company_id-projects-member-allocation"
      }, {
        path: "new",
        component: _a093b0ce,
        name: "companies-company_id-projects-new"
      }, {
        path: ":id",
        component: _c7ff5a9a,
        children: [{
          path: "",
          component: _6bc2c6f6,
          name: "companies-company_id-projects-id"
        }, {
          path: "attendance",
          component: _1f9746b8,
          name: "companies-company_id-projects-id-attendance"
        }, {
          path: "board_posts",
          component: _108be261,
          name: "companies-company_id-projects-id-board_posts"
        }, {
          path: "card",
          component: _56fc211f,
          name: "companies-company_id-projects-id-card"
        }, {
          path: "detail",
          component: _b62db146,
          name: "companies-company_id-projects-id-detail"
        }, {
          path: "member",
          component: _da8565b4,
          name: "companies-company_id-projects-id-member"
        }, {
          path: "reports",
          component: _2bb5aea6,
          name: "companies-company_id-projects-id-reports"
        }, {
          path: "schedule",
          component: _255321e6,
          name: "companies-company_id-projects-id-schedule"
        }, {
          path: "attendance/summary",
          component: _3ea7600c,
          name: "companies-company_id-projects-id-attendance-summary"
        }, {
          path: "attendance/user-list",
          component: _8fa64574,
          name: "companies-company_id-projects-id-attendance-user-list"
        }, {
          path: "attendance/user-records",
          component: _089ee66c,
          name: "companies-company_id-projects-id-attendance-user-records"
        }, {
          path: "attendance/utils",
          component: _46e93ace,
          name: "companies-company_id-projects-id-attendance-utils",
          children: [{
            path: "user-list",
            component: _7975e446,
            name: "companies-company_id-projects-id-attendance-utils-user-list"
          }]
        }, {
          path: "board_posts/new",
          component: _2076ddef,
          name: "companies-company_id-projects-id-board_posts-new"
        }, {
          path: "board_posts/posts",
          component: _771fa1e5,
          name: "companies-company_id-projects-id-board_posts-posts"
        }, {
          path: "reports/select-daily-reports",
          component: _b0967e54,
          name: "companies-company_id-projects-id-reports-select-daily-reports"
        }, {
          path: "schedule/fullscreen",
          component: _43b626d7,
          name: "companies-company_id-projects-id-schedule-fullscreen"
        }, {
          path: "schedule/preview",
          component: _8206fa48,
          name: "companies-company_id-projects-id-schedule-preview"
        }, {
          path: "schedule/print",
          component: _7a0e5804,
          name: "companies-company_id-projects-id-schedule-print"
        }, {
          path: "schedule/view",
          component: _25a12584,
          name: "companies-company_id-projects-id-schedule-view"
        }, {
          path: "schedule/view/fullscreen",
          component: _704fb5f9,
          name: "companies-company_id-projects-id-schedule-view-fullscreen"
        }, {
          path: "board_posts/:board_id",
          component: _1692a5f6,
          name: "companies-company_id-projects-id-board_posts-board_id"
        }, {
          path: "files/:file_id",
          component: _b44af334,
          name: "companies-company_id-projects-id-files-file_id"
        }, {
          path: "board_posts/:board_id/edit",
          component: _dbad7cb2,
          name: "companies-company_id-projects-id-board_posts-board_id-edit"
        }, {
          path: "board_posts/:board_id/files",
          component: _4973b9a6,
          name: "companies-company_id-projects-id-board_posts-board_id-files"
        }, {
          path: "files/:file_id/edit",
          component: _af378fb4,
          name: "companies-company_id-projects-id-files-file_id-edit"
        }, {
          path: "files/:file_id/preview",
          component: _3b3cc75c,
          name: "companies-company_id-projects-id-files-file_id-preview"
        }, {
          path: "reports/:report_id/form",
          component: _3bb4dd20,
          name: "companies-company_id-projects-id-reports-report_id-form"
        }, {
          path: "reports/:report_id/preview",
          component: _04c1e7c8,
          name: "companies-company_id-projects-id-reports-report_id-preview"
        }]
      }]
    }, {
      path: "/companies/:company_id/reports",
      component: _b3e61638,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _33a51732,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _4cc6f288,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _cec2ccfc,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _0dcb44b5,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _093baf07,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _9c4e0462,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _984a1136,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _4af64bbd,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/ai_pdf",
      component: _20f736ae,
      name: "companies-company_id-reports-id-ai_pdf"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _5e74af9d,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _ea8fe9a2,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _1a219ef3,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _370647bb,
      name: "index"
    }],

    fallback: false
  })
}
